import type { ApiPage } from '@/types/api';

export interface UseSeoOptions {
  page?: MaybeRefOrGetter<ApiPage | null>;
  title?: MaybeRefOrGetter<string>;
  description?: MaybeRefOrGetter<string>;
}

export const useSeo = (options: UseSeoOptions) => {
  const { page, title, description } = options;

  const preparedTitle = computed(
    () => toValue(title) || toValue(page)?.meta?.seo_title || '',
  );
  const preparedDescription = computed(
    () => toValue(description) || toValue(page)?.meta?.search_description || '',
  );

  useSeoMeta({
    title: preparedTitle,
    ogTitle: preparedTitle,
    ogType: 'website',
    description: preparedDescription,
    ogDescription: preparedDescription,
    twitterCard: 'summary_large_image',
  });

  defineOgImage('OgImageDefault', {
    title: toValue(preparedTitle),
    description: toValue(preparedDescription),
  });
};
